import { inject } from 'vue'
import { ProviderKeys } from '@/app/providers/provider-keys.ts'

export function useAppRoutes() {
  const appRoutes = inject(ProviderKeys.AppRoutes)

  if (!appRoutes) {
    throw new Error('Could not find provider AppRoutes')
  }

  return appRoutes
}
